/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:center}.overlay-container[_ngcontent-%COMP%]{padding:30px 20px;background:#fff;border-radius:3px;max-width:400px}.modal-title[_ngcontent-%COMP%]{margin:0}.modal-message[_ngcontent-%COMP%]{font-family:'Space Mono';margin:0}.modal-close-button[_ngcontent-%COMP%]{margin-top:20px;width:100%}@media (min-width:520px){.overlay-container[_ngcontent-%COMP%]{padding:30px}}@media (min-width:768px){.overlay-container[_ngcontent-%COMP%]{padding:30px 58px}}"];
export { styles as styles };
